<template>
  <div id="bar-chart">
    <div id="chart-container">
      <fusioncharts
        :type="type"
        :width="width"
        :height="height"
        :dataformat="dataFormat"
        :dataSource="dataSource"
      >
      </fusioncharts>
    </div>
  </div>
</template>
<script>
export default {
  name: "app",
  data() {
    return {
      type: "column2d",
      renderAt: "chart-container",
      width: "100%",
      height: "350",
      dataFormat: "json",
      dataSource: {
        chart: {
          caption: "",
          subCaption: "",
          numberPrefix: "",
          theme: "fusion"
        },
        data: []
      }
    };
  },
  methods: {
    init(val) {
      this.dataSource.data = val;
    }
  }
};
</script>
